import { type SetNonNullable } from "type-fest"

export function isKeyOf<TMap extends object>(key: unknown, map: TMap): key is keyof TMap {
    return (
        (typeof key === "string" || typeof key === "number" || typeof key === "symbol") &&
        key in map
    )
}

export function getMapKeyOr<TValue, TFallback>(
    key: unknown,
    map: Record<string | number | symbol, TValue>,
    fallback: TFallback
) {
    return isKeyOf(key, map) ? map[key] : fallback
}

export function hasFields<TItem extends Record<string, unknown>, TKey extends string>(
    item: TItem,
    keys: Array<TKey>
): item is SetNonNullable<TItem, TKey> {
    return keys.every((key) => !!item[key])
}
